import * as React from 'react';

interface ErrorBoundaryState {
  error: Error | null;
}

/** Keeps a runtime error from turning the whole app into a blank page. */
export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  override state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  override componentDidCatch(error: Error): void {
    console.error('FlowShare crashed', error);
  }

  override render(): React.ReactNode {
    if (!this.state.error) return this.props.children;

    return (
      <div className="grid min-h-dvh place-items-center p-6">
        <div className="surface w-full max-w-md rounded-2xl p-8 text-center">
          <div className="mx-auto grid size-12 place-items-center rounded-2xl border border-destructive/25 bg-destructive/10">
            <span className="text-lg text-destructive">!</span>
          </div>
          <h1 className="mt-5 text-xl font-semibold tracking-[-0.03em]">Something broke</h1>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
            FlowShare hit an unexpected error. Reloading usually fixes it. No files were uploaded
            anywhere.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 inline-flex h-10 items-center justify-center rounded-xl bg-primary px-4 text-sm font-medium text-primary-foreground"
          >
            Reload FlowShare
          </button>
        </div>
      </div>
    );
  }
}
